import { Link } from 'react-router-dom';
import startWorking from '../../images/start-working.png';

function DailyJobCard({ title, subject, price, perUnit, img, to }) {
    return (
        <div className="job-card">
            <div className="icon"><img src={img} alt='job'></img></div>
            <div className="job-content-wrp">
                <div className="jc-title">{title}</div>
                <div className="jc-subject">{subject}</div>
                <div className="jc-price"><span className="price">{price}</span> {perUnit}</div>
                <div className="jc-start-working-wrp">
                    <Link reloadDocument={true} to={to}>
                        <div className="title">Start Working</div>
                        <img src={startWorking} alt='start-working'></img>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default DailyJobCard;